"use strict";
var Observable_1 = require('../../Observable');
var race_1 = require('../../operator/race');
Observable_1.Observable.prototype.race = race_1.race;
//# sourceMappingURL=race.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/rxjs/add/operator/race.js
// module id = ../../../../rxjs/add/operator/race.js
// module chunks = 16